import React from "react";
import { ArrowRight } from "lucide-react";
import { services } from "./servicesData";
import useScrollToHash from "./useScrollToHash";
import { Link } from "react-router-dom";

const BANNER_IMG =
  "./img/breadcrumb-bg.jpg";
export default function Services() {
  useScrollToHash();

  return (
    <>
      <section
              className="rx-page-banner"
              style={{ backgroundImage: `url(${BANNER_IMG})` }}
            >
              <div className="rx-page-banner-overlay" />
              <div className="rx-page-banner-inner">
                <h1>Services</h1>
                <div className="rx-breadcrumb">
                  <Link to="/">Home</Link>
                  <span>»</span>
                  <span className="current">Services</span>
                </div>
              </div>
            </section>

      {services.map((s, i) => {
        const Icon = s.icon;
        const alt = i % 2 !== 0;
        return (
          <section
            id={s.slug}
            key={s.slug}
            className="rx-d2d"
            style={{ background: alt ? "var(--canvas)" : "#fff", scrollMarginTop: 90 }}
          >
            <div className="rx-d2d-grid">
              <div style={{ order: alt ? 2 : 1 }}>
                <div className="rx-product-icon" style={{ marginBottom: 20 }}>
                  <Icon size={22} />
                </div>
                <h2>{s.title}</h2>
                <p className="rx-lead">{s.body}</p>
                <Link to="/contact"><button className="rx-btn-dark">
                  Get Quote Now <ArrowRight size={16} />
                </button></Link>
              </div>
              <div className="rx-service-img-wrap" style={{ order: alt ? 1 : 2 }}>
                <img src={s.image} alt={s.title} />
              </div>
            </div>
          </section>
        );
      })}
    </>
  );
}